import { render, staticRenderFns } from "./TablePager.vue?vue&type=template&id=003bc1e0"
import script from "./TablePager.vue?vue&type=script&lang=js"
export * from "./TablePager.vue?vue&type=script&lang=js"
import style0 from "./TablePager.vue?vue&type=style&index=0&id=003bc1e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports